export type ConvertToManagedDisabledReason =
  | "role"
  | "restricted"
  | "expired"
  | "unavailable";

export interface ConvertToManagedMenuStateInput {
  isFeatureEnabled: boolean;
  isManagedConnectionsEntitled: boolean;
  isManaged: boolean;
  isOwnerOrSuperAdmin: boolean;
  hasConvertPermission: boolean;
  isRestricted: boolean;
  isExpired: boolean;
}

export type ConvertToManagedMenuState =
  | { isVisible: false }
  | { isVisible: true; disabledReason?: ConvertToManagedDisabledReason };

/** Decides whether the "Convert to managed" item shows and, if disabled, the first reason why. */
export function getConvertToManagedMenuState({
  isFeatureEnabled,
  isManagedConnectionsEntitled,
  isManaged,
  isOwnerOrSuperAdmin,
  hasConvertPermission,
  isRestricted,
  isExpired,
}: ConvertToManagedMenuStateInput): ConvertToManagedMenuState {
  if (!isFeatureEnabled || !isManagedConnectionsEntitled || isManaged) {
    return { isVisible: false };
  }
  if (!isOwnerOrSuperAdmin) return { isVisible: true, disabledReason: "role" };
  if (isRestricted) return { isVisible: true, disabledReason: "restricted" };
  if (isExpired) return { isVisible: true, disabledReason: "expired" };
  if (!hasConvertPermission) {
    return { isVisible: true, disabledReason: "unavailable" };
  }
  return { isVisible: true };
}
